// The widget snippet customers paste into their site. Shared by the onboarding
// install step and the Install & Settings page so the two can't drift apart.
//
// This takes the record's `publicId` (asst_XXXXXX), not its internal `id` —
// the snippet is served on the customer's public pages, so the id that ends up
// in it should be the one meant to be seen.

export const WIDGET_SRC = process.env.REACT_APP_WIDGET_URL || "";

export const buildEmbedSnippet = (publicId) => `<script
  src="${WIDGET_SRC}"
  data-hostor-id="${publicId}"
  defer>
</script>`;

// The same lines, split up so the block can be syntax-coloured without the
// rendered markup and the copied text ever disagreeing.
export const buildEmbedLines = (publicId) => [
  { tag: "<script" },
  { indent: true, attr: "src", value: WIDGET_SRC },
  { indent: true, attr: "data-hostor-id", value: publicId },
  { indent: true, attr: "defer", tag: ">" },
  { tag: "</script>" },
];
